module.exports = __webpack_public_path__ + "img/arrow-simple-forward.e71f34f5.svg";